// Immagini di default del sito. Possono essere sovrascritte dal pannello di modifica (salvate nel database).
export const defaultImages = {
  hero: [
    "/images/slide-vini-quadro.webp",
    "/images/slide-servizio.webp",
    "/images/slide-cucina-vintage.webp",
    "/images/slide-culurgiones.webp",
    "/images/slide-dehors.webp",
    "/images/slide-tappi.webp",
    "/images/slide-cozze-padella.webp",
    "/images/slide-cozze-terracotta.webp",
  ],
  sapori: [
    "/images/sapori-1-vini-korem.webp",
    "/images/sapori-2-servizio.webp",
    "/images/sapori-3-cozze.webp",
    "/images/sapori-4-malloreddus.webp",
  ],
  locale: {
    facade: "/images/facciata-sera.webp",
    room: "/images/sala-pietra.webp",
    corner: "/images/angolo-mare.webp",
    welcome: "/images/accoglienza-dehors.webp",
  },
  contatti: {
    door: "/images/gallery/z-34.webp",
  },
  signature: {
    dish: "/images/gallery/z-56.webp",
  },
  servizi: {
    regalo: "/images/tavola-calici.webp",
    domicilio: "/images/insalata-mare.webp",
    sala: "/images/sala-sedie-rosse.webp",
  },
  gallery: [
    "/images/gallery/z-09.webp",
    "/images/gallery/z-53.webp",
    "/images/gallery/z-31.webp",
    "/images/gallery/z-05.webp",
    "/images/gallery/z-45.webp",
    "/images/gallery/z-11.webp",
    "/images/gallery/z-33.webp",
    "/images/gallery/z-18.webp",
    "/images/gallery/z-47.webp",
    "/images/gallery/z-24.webp",
    "/images/gallery/z-42.webp",
    "/images/gallery/z-13.webp",
    "/images/gallery/z-56.webp",
    "/images/gallery/z-21.webp",
    "/images/gallery/z-40.webp",
    "/images/gallery/z-29.webp",
    "/images/gallery/z-36.webp",
    "/images/gallery/z-46.webp",
    "/images/gallery/z-06.webp",
    "/images/gallery/z-32.webp",
    "/images/gallery/z-49.webp",
    "/images/gallery/z-26.webp",
    "/images/gallery/z-59.webp",
    "/images/gallery/z-16.webp",
    "/images/gallery/z-51.webp",
    "/images/gallery/z-08.webp",
    "/images/gallery/z-41.webp",
    "/images/gallery/z-12.webp",
    "/images/gallery/z-54.webp",
    "/images/gallery/z-22.webp",
    "/images/gallery/z-44.webp",
    "/images/gallery/z-17.webp",
    "/images/gallery/z-57.webp",
    "/images/gallery/z-25.webp",
    "/images/gallery/z-48.webp",
    "/images/gallery/z-10.webp",
    "/images/gallery/z-30.webp",
    "/images/gallery/z-52.webp",
    "/images/gallery/z-27.webp",
    "/images/gallery/z-43.webp",
    "/images/gallery/z-14.webp",
    "/images/gallery/z-55.webp",
    "/images/gallery/z-23.webp",
    "/images/gallery/z-60.webp",
    "/images/gallery/z-19.webp",
    "/images/gallery/z-50.webp",
    "/images/gallery/z-34.webp",
    "/images/gallery/z-15.webp",
    "/images/gallery/z-20.webp",
    "/images/gallery/z-37.webp",
    "/images/gallery/z-38.webp",
    "/images/gallery/z-39.webp",
    "/images/gallery/z-04.webp",
    "/images/gallery/z-07.webp",
    "/images/gallery/z-28.webp",
    "/images/gallery/z-35.webp",
  ],
};

// Libreria di tutte le foto disponibili (per la scelta dal pannello).
export const imageLibrary = Array.from(
  new Set([
    ...defaultImages.hero,
    ...defaultImages.sapori,
    ...Object.values(defaultImages.locale),
    ...Object.values(defaultImages.contatti),
    ...Object.values(defaultImages.signature),
    ...Object.values(defaultImages.servizi),
    ...defaultImages.gallery,
    "/images/plateau-crudi.webp",
    "/images/tagliere-aperitivo.webp",
    "/images/tavola-calici.webp",
    "/images/hero-locale.webp",
  ])
);
